import React, { useEffect, useRef, useState } from 'react';
import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity';
import { Delete, Lock, Save } from '@material-ui/icons';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Clearfix from 'components/Clearfix/Clearfix.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardAvatar from 'components/Card/CardAvatar.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.js';
import { wsGet, wsPost, wsUpdate } from 'services/WService';
import Badge from 'components/Badge/Badge';
import moment from 'moment';
import { TextField } from '@material-ui/core';
import { Toasty, useToasty } from 'hooks/Toasty';
import SvgString from 'components/Tvendo/Common/SvgString';
import Modal from 'components/Tvendo/Common/ModalBase';
import { useModal } from 'hooks/useModal';
import * as QRCode from 'qrcode';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText  from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import { formatDate } from 'hooks/Pipe';

const useStyles = makeStyles({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const Modal2FA = (props) => {
  const { showNotify, model, setOpen } = props;
  const { dataUser, setDataUser } = props;
  const [qrData, setQrData] = useState();
  const [secret, setSecret] = useState();
  const [codeString, setCodeString] = useState('');
  const [processing, setProcessing] = useState(false);

  async function get2FAQrCode() {
    let res = await wsGet('/v2/auth/2fa/secret-key');
    if (res.success) {
      setSecret(res.secret);
      setQrData(await QRCode.toString(res.data));
    }
  }

  async function activate2FA() {
    let data = { secret_key: secret, key: codeString };
    setProcessing(true);
    let res = await wsPost('/v2/auth/2fa/save-key', data);
    setProcessing(false);
    if (res.success) {
      showNotify(res.message);
      let user = JSON.parse(localStorage.getItem('user_data'));
      user['2fa_enable'] = true;
      localStorage.setItem('user_data', JSON.stringify(user));
      setOpen({ open: false });
      setDataUser(user);
      setCodeString('');
      setQrData(undefined);
      setSecret(undefined);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function desactivate2FA() {
    setProcessing(true);
    let res = await wsPost('/v2/auth/2fa/drop-key', { key: codeString });
    setProcessing(false);
    if (res.success) {
      showNotify(res.message);
      let user = JSON.parse(localStorage.getItem('user_data'));
      user['2fa_enable'] = false;
      localStorage.setItem('user_data', JSON.stringify(user));
      setOpen({ open: false });
      setDataUser(user);
      setCodeString('');
      setQrData(undefined);
      setSecret(undefined);
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    if (dataUser['2fa_enable'] === false) {
      get2FAQrCode();
    }
  }, [dataUser]);

  return (
    <Modal
      title="Factor de doble autenticación"
      model={model}
      setOpen={setOpen}
      entity=""
      maxWidth={'xs'}
      onSubmit={() => {}}
      hideSave
    >
      {dataUser['2fa_enable'] === false ? (
        <GridContainer>
          <GridItem xs={12} style={{ display: 'flex' }}>
            {qrData !== undefined && <SvgString image={qrData} />}
          </GridItem>
          <GridItem xs={12}>
            <TextField
              label="Código"
              fullWidth
              value={codeString}
              onChange={(e) => setCodeString(e.target.value)}
            />
          </GridItem>
          <GridItem xs={12}>
            <Button
              color="success"
              fullWidth
              round
              disabled={processing || codeString.length !== 6}
              onClick={() => activate2FA()}
            >
              Activar
            </Button>
          </GridItem>
        </GridContainer>
      ) : (
        <GridContainer>
          <GridItem xs={12}>
            <TextField
              label="Código"
              fullWidth
              value={codeString}
              onChange={(e) => setCodeString(e.target.value)}
            />
          </GridItem>
          <GridItem xs={12}>
            <Button
              color="danger"
              fullWidth
              round
              disabled={processing || codeString.length !== 6}
              onClick={() => desactivate2FA()}
            >
              Desactivar
            </Button>
          </GridItem>
        </GridContainer>
      )}
    </Modal>
  );
};

function CardList({ title, data = [], fieldValue }) {
  const classes = useStyles();
  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary">
          <PermIdentity />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>{title}</h4>
      </CardHeader>
      <CardBody>
        {data.map((item, i) => {
          return (
            <Badge key={i} color="info" style={{ marginRight: '10px' }}>
              {item[fieldValue]}
            </Badge>
          );
        })}
      </CardBody>
    </Card>
  );
}

export default WithApp(function UserCreate(props) {
  const classes = useStyles();
  const formChangePass = useRef(null);
  const [notify, showNotify] = useToasty();

  const [dataUser, setDataUser] = useState({});
  const [processing, setProcessing] = useState(false);

  const [pass, setPass] = useState({});
  const handleChange = (e) => {
    setPass({ ...pass, [e.target.name]: e.target.value });
  };

  async function deleteToken(token) {
    let confirm = window.confirm('Esta seguro de eliminar este token?');
    if (!confirm) return;
    setProcessing(true);
    let res = await wsPost('oauth/delete-token', {
      tokenId: token.id,
    });
    if (res.success) {
      await getUser();
      window.alert(res.message);
    } else {
      window.alert(res.message);
    }
    setProcessing(false);
  }

  async function deleteAllTokens() {
    let confirm = window.confirm('Esta seguro de eliminar todos los accesos excepto el actual?');
    if (!confirm) return;
    
    setProcessing(true);
    let res = await wsPost('oauth/delete-all-tokens');
    if (res.success) {
      await getUser();
      window.alert(res.message);
    } else {
      window.alert(res.message);
    }
    setProcessing(false);
  }

  async function getUser() {
    let response = await wsGet('oauth/user/current?with_roles=Y&with_zones=Y&with_warehouses=Y&with_tokens=Y');
    if (response.success) setDataUser(response.data);
  }

  async function changePass() {
    if (pass.newPassword !== pass.confirmPass) {
      showNotify('Las contraseñas no coinciden', 'warning');
      return;
    }
    let response = await wsUpdate('oauth/user/current', pass);
    if (response.success) {
      showNotify(response.message);
      setPass({});
    } else {
      showNotify(response.message, 'error');
    }
  }

  const [model, setOpen] = useModal();

  useEffect(() => {
    getUser();
  }, []);

  return (
    <GridContainer>
      <Modal2FA
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        setDataUser={setDataUser}
        dataUser={dataUser}
      />
      <Toasty action={notify} />
      {/* Contraseña / 2fa */}
      <GridItem xs={12} sm={12} md={3}>
        <Card profile>
          <CardAvatar profile>
            <img
              src={'https://gravatar.com/avatar/fa110e100fd09cd4ebb854f9ac8981c5?s=&d=mp'}
              alt="..."
            />
          </CardAvatar>
          <CardBody profile>
            <h6 className={classes.cardCategory}>{dataUser.email}</h6>
            <h4 className={classes.cardTitle}>{dataUser.name}</h4>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                changePass();
              }}
              ref={formChangePass}
            >
              <TextField
                label="Contraseña"
                type="password"
                value={pass.password || ''}
                name="password"
                onChange={handleChange}
                size="small"
                margin="normal"
                fullWidth
                required
              />
              <TextField
                label="Nueva contraseña"
                type="password"
                value={pass.newPassword || ''}
                name="newPassword"
                onChange={handleChange}
                size="small"
                margin="normal"
                fullWidth
                required
              />
              <TextField
                label="Confirmar contraseña"
                type="password"
                value={pass.confirmPass || ''}
                name="confirmPass"
                onChange={handleChange}
                size="small"
                margin="normal"
                fullWidth
                required
              />
              <Button
                type="submit"
                round
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
                fullWidth
              >
                <Save /> Guardar
              </Button>

              {dataUser['2fa_enable'] === true ? (
                <Button
                  color="danger"
                  fullWidth
                  round
                  className={classes.marginRight}
                  onClick={() => setOpen()}
                >
                  Desactivar 2FA
                </Button>
              ) : (
                <Button
                  color="success"
                  fullWidth
                  round
                  className={classes.marginRight}
                  onClick={() => setOpen()}
                >
                  Activar 2FA
                </Button>
              )}
            </form>
          </CardBody>
        </Card>
      </GridItem>
      {/* Derecha */}
      <GridItem xs={12} sm={12} md={9}>
        <GridContainer>
          {/* Contraseña / 2fa */}
          <GridItem xs={12} sm={4} lg={12} xl={12}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Datos de usuario</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <h6>E-mail</h6>
                    <span>{dataUser.email || '-'}</span>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <h6>Telefono</h6>
                    <span>{dataUser.phone || '-'}</span>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <h6>Fec. nacimiento</h6>
                    <span>{moment(dataUser.birthday).format('YYYY-MM-DD') || '-'}</span>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <h6>Genero</h6>
                    <span>{dataUser.gender ? dataUser.gender : '-'}</span>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <h6>Tipo de usuario</h6>
                    <span>{dataUser.type ? (dataUser.type == 'A' ? 'Web' : 'Movil') : '-'}</span>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <h6>Dirección</h6>
                    <span>{dataUser.address || '-'}</span>
                  </GridItem>
                </GridContainer>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>

          {/* Roles */}
          <GridItem xs={12} sm={4} lg={4} xl={4}>
            <CardList title="Roles" data={dataUser.roles} fieldValue="name" />
          </GridItem>

          {/* Zonas */}
          <GridItem xs={12} sm={4} lg={4} xl={4}>
            <CardList title="Zonas" data={dataUser.zones} fieldValue="description" />
          </GridItem>

          {/* Almacenes */}
          <GridItem xs={12} sm={4} lg={4} xl={4}>
            <CardList title="Almacénes" data={dataUser.warehouses} fieldValue="WhsName" />
          </GridItem>
        </GridContainer>
      </GridItem>

      {/* Tokens */}
      {!!dataUser.tokens && (
        <GridItem xs={12} sm={12} md={3}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Lock />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Tokens de acceso
                <Button
                  color="danger"
                  round
                  justIcon
                  size="sm"
                  onClick={() => deleteAllTokens()}
                  disabled={processing}
                >
                  <Delete />
                </Button>
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <List>
                    {dataUser.tokens.map((token) => {
                      return (
                        <ListItem key={token.id} role={undefined} dense button>
                          <ListItemText
                            id={token.id}
                            primary={`${formatDate(token.created_at)} - ${
                              token.ip_logged || 'Ip no definido'
                            }${!!token.navigator ? ` - ${token.navigator}` : ''}`}
                          />
                          <ListItemSecondaryAction>
                            <IconButton
                              color="secondary"
                              edge="end"
                              onClick={() => deleteToken(token)}
                              disabled={processing}
                            >
                              <Delete />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      )}
    </GridContainer>
  );
});
